export default "__VITE_ASSET__DMUnA3Ap__"